const EDUCATION_STYLES = [
    { value: 'Presential', label: 'Presencial' },
    { value: 'Remote', label: 'Remoto' },
    { value: 'Hybrid', label: 'Híbrido' },
]

export default EDUCATION_STYLES